export const START_FETCHING_CATEGORIES =
  'redux/categories/START_FETCHING_CATEGORIES';
export const SUCCESS_FETCHING_CATEGORIES =
  'redux/categories/SUCCESS_FETCHING_CATEGORIES';
export const ERROR_FETCHING_CATEGORIES =
  'redux/categories/ERROR_FETCHING_CATEGORIES';